import { useClient } from '../../../ClientProvider';
import useMutation from '../../../useMutation';
import useDecitraitCreateOrUpdatePlot from './useDecitraitCreateOrUpdatePlot';
/** Create a decitrait plot matching the name of a weenat plot, may return null if the decitrait resources is not available */
export const useDecitraitCreatePlot = ({ plot, onSuccess }) => {
    const client = useClient();
    const [createPlot, createPlotRequest] = useMutation(client.decitrait.createPlot(), { onSuccess });
    const createOrUpdatePlot = useDecitraitCreateOrUpdatePlot({
        plot,
        mutate: (x) => createPlot({ ...x, plotId: plot.id }),
        request: createPlotRequest
    });
    if (!createOrUpdatePlot)
        return null;
    const { props } = createOrUpdatePlot;
    return {
        props
    };
};
